import {Box, Skeleton} from '@mantine/core';
import type {FC} from 'react';
import {LIIGA} from '../../../../../config/constants/routes';
import {CommonLink} from '../../../../../shared/components/CommonLink';

export const GraduatedUserReportBox: FC = () => {
  return (
    <Box className="relative">
      <Box className="flex flex-col bg-white rounded-4 rounded-b-12 px-16 py-24 mb-16">
        <Box className="w-full flex flex-col gap-12 blur-sm">
          <Skeleton height={24} width={120} animate={false} />
          <Skeleton height={16} animate={false} />
          <Skeleton height={16} animate={false} width={220} />
          <Skeleton height={16} animate={false} />
          <Skeleton height={16} animate={false} width={200} />
        </Box>
        <Box className="w-full flex flex-col gap-12 blur-sm">
          <Skeleton height={24} width={180} animate={false} />
          <Skeleton height={24} width={180} animate={false} />
          <Skeleton height={16} animate={false} width={240} />
        </Box>
      </Box>
      <Box className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col bg-white shadow-modal-lg p-16 py-20 rounded-16 w-11/12 pc:w-2/3">
        <Box className="text-black-1 pc:text-center text-md">
          ES・体験記は在学中のユーザーのみ閲覧可能です
          <br />
          <p className="mt-12 text-black-1 text-md">
            社会人向けキャリア支援サービス 外資就活ネクストは
            <CommonLink
              href={LIIGA}
              className="mt-16 text-link leading pc:hover:opacity-80"
            >
              こちら
            </CommonLink>
            <br />
            ※外資就活ドットコムの登録アドレスでログインが可能です
          </p>
        </Box>
      </Box>
    </Box>
  );
};
